import request from '@/utils/request'
import ObjectFunc from '@/tbs/util/ObjectFunc'

export function getClubList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetOrganizationList.json',
    method: 'post',
    data
  })
}

export function getClubEdit(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetOrganization.json',
    method: 'post',
    data
  })
}

export function updateClubEdit(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateOrganization.json',
    method: 'post',
    data
  })
}

export function getOrganizationPlayerList(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetOrganizationPlayerList.json',
    method: 'post',
    data
  })
}

export function updateOrganizationPlayerStatus(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/UpdateOrganizationPlayerStatus.json',
    method: 'post',
    data
  })
}

/**
 * The player organization section
 */
export function getOrganizationPlayerRegList(params) {
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/organization_player/',
        method: 'get',
        params
    }) 
}

export function getOrganizationPlayerRegListPagination(params) {
    ObjectFunc.mergeObject(params, {accessKey: 'bjh-admin-rpes'})
    return request({
        url: process.env.BJH_STATS_API + '/api/rpes/organization_player/pagination',
        method: 'get',
        params
    }) 
}